import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Scroll from 'react-scroll';
import { isValid, getFormSyncErrors, getFormValues, touch } from 'redux-form';
import classnames from 'classnames';
import {
  Container,
  Grid,
  GridColumn,
  Dimmer,
  Loader,
  Button,
  Icon,
} from 'semantic-ui-react';
import MobileTips from './common/MobileTips';
import * as formStructureActions from '../store/formStructure/formStructureActions';
import * as showSeasonActions from '../store/showSeason/showSeasonActions';
import Step1 from './apply/Step1.js';
import Step2 from './apply/Step2.js';
import Step3 from './apply/Step3.js';
import Step4 from './apply/Step4.js';
import TermsOfService from './TermsOfService';
import { Redirect } from 'react-router';

const tips =
  '<div><p>Make sure all of your information is correct before moving on to the next step! </p><p>Do not refresh your browser while completing the application, otherwise your application progress will be lost and you must start again. </p> </div>';

class Apply extends PureComponent {
  static propTypes = {
    loading: PropTypes.bool.isRequired,
    show: PropTypes.object.isRequired,
    season: PropTypes.object.isRequired,
    sections: PropTypes.object.isRequired,
    getFormInformation: PropTypes.func.isRequired,
    applicants: PropTypes.number.isRequired,
    optionByField: PropTypes.object.isRequired,
    finalForm: PropTypes.object.isRequired,
    setFormTouch: PropTypes.func.isRequired,
    submitApplicants: PropTypes.func.isRequired,
    termsOfServiceForm: PropTypes.object,
    country: PropTypes.string.isRequired,
  };
  static defaultProps = {
    termsOfServiceForm: {},
  };
  constructor(props) {
    super(props);
    this.scroller = Scroll.scroller;
    const { REACT_APP_SKIP_VIDEO, REACT_APP_SKIP_PHOTO, REACT_APP_UNDER_EIGHTEEN } = process.env;
    this.skipPhoto = REACT_APP_SKIP_PHOTO == "1" ? true : false;
    this.skipVideo = REACT_APP_SKIP_VIDEO == "1" ? true : false;

    this.stepsCount = this.skipPhoto && this.skipVideo ? 2 : (this.skipPhoto || this.skipVideo ? 3 : 4);
    this.underEighteen = REACT_APP_UNDER_EIGHTEEN == "1" ? 1 : 0;
    this.state = {
      stepIndex: 1,
      tabIndex: 0,
      visible: false,
      isFinalStep: false,
      tabsBySteps: {
        1: this.props.applicants,
        2: this.props.applicants - 1,
        3: this.skipPhoto ? 0 : this.props.applicants,
        4: 0,
      },
      skipPhoto: this.skipPhoto,
      skipVideo: this.skipVideo,
      stepsCount: this.stepsCount,
      before: '',
      after: '',
    };
  }

  componentDidMount = () => {
    window.scrollTo(0, 0);
    if (this.props.season.externalIdC && this.props.country) {
      this.props.getFormInformation(this.props.season.externalIdC, this.props.country);
    }
  };

  componentDidUpdate(prevProps) {
    if (
      (this.props.season.externalIdC &&
        prevProps.season.externalIdC !== this.props.season.externalIdC) ||
      (this.props.country && prevProps.country !== this.props.country)
    ) {
      this.props.getFormInformation(
        this.props.season.externalIdC,
        this.props.country
      );
    }
  }


  setStepIndex = index => {
    if (this.props.applicants > 1) {


      //this.setState({
      //  before: 'applicants: ' + this.props.applicants +
      //    ', stepsCount: ' + this.state.stepsCount +
      //    ', tabsBySteps: ' + this.state.tabsBySteps[this.state.stepIndex] +
      //    ', stepIndex: ' + this.state.stepIndex +
      //    ', tabIndex: ' + this.state.tabIndex +
      //    ', skipPhoto: ' + (this.state.skipPhoto ? 'true' : 'false') +
      //    ', skipVideo: ' + (this.state.skipVideo ? 'true' : 'false') +
      //    ', isFinalStep: ' + (this.state.isFinalStep ? 'true' : 'false')
      //});


      if (index > 0) {

        if (parseInt(this.state.tabIndex) < parseInt(this.state.tabsBySteps[this.state.stepIndex])) {
          this.setState({ tabIndex: parseInt(this.state.tabIndex + 1), });


        } else if (parseInt(this.state.stepIndex) < parseInt(this.state.stepsCount)) {
          this.setState({
            stepIndex: parseInt(this.state.stepIndex) + 1,
            tabIndex: 0,
          });

        }

        if (parseInt(this.state.stepIndex) == parseInt(this.state.stepsCount) && parseInt(this.state.tabIndex + 1) >= parseInt(this.state.tabsBySteps[this.state.stepIndex])) {
          this.setState({ isFinalStep: true, });
        }


      } else {

        if (this.state.isFinalStep) {
          this.setState({ isFinalStep: false, });
        }

        if (parseInt(this.state.tabIndex) === 0) {
          this.setState({
            tabIndex: this.state.tabsBySteps[this.state.stepIndex - 1],
            stepIndex: parseInt(this.state.stepIndex) - 1,
          });



        } else {
          this.setState({ tabIndex: parseInt(this.state.tabIndex) - 1, });
        }

      }

      //this.setState({
      //  after: 'applicants: ' + this.props.applicants +
      //    ', stepsCount: ' + this.state.stepsCount +
      //    ', tabsBySteps: ' + this.state.tabsBySteps[this.state.stepIndex] +
      //    ', stepIndex: ' + this.state.stepIndex +
      //    ', tabIndex: ' + this.state.tabIndex +
      //    ', skipPhoto: ' + (this.state.skipPhoto ? 'true' : 'false') +
      //    ', skipVideo: ' + (this.state.skipVideo ? 'true' : 'false') +
      //    ', isFinalStep: ' + (this.state.isFinalStep ? 'true' : 'false')
      //});


    } else {

      if (this.state.stepIndex + index === this.state.stepsCount) {
        this.setState({ isFinalStep: true });
      } else {
        this.setState({ isFinalStep: false });
      }

      this.setState({ stepIndex: this.state.stepIndex + index });

    }
  };

  toggleVisibility = () => this.setState({ visible: !this.state.visible });

  closeMenu = () => this.setState({ visible: false });

  changeStep = index => {
    this.scroller.scrollTo('applyProgress', {
      duration: 500,
      delay: 100,
      smooth: true,
    });
    if (index > 0) {
      if (this.props.applicants === 1) {
        if (this.props[`member${this.state.tabIndex + 1}IsValid`]) {
          this.setStepIndex(index);
        } else {
          this.props.setFormTouch(
            `member${this.state.tabIndex + 1}`,
            Object.keys(
              this.props[`member${this.state.tabIndex + 1}SyncErrors`]
            )
          );
        }
      } else {
        let formName = `member${this.state.tabIndex + 1}`;
        if (
          (this.state.tabIndex === this.props.applicants &&
            this.state.stepIndex !== 2) ||
          (this.props.applicants > 1 && ((this.state.stepIndex === 3 && this.state.skipPhoto) || (this.state.stepIndex === 4)))
        ) {
          formName = 'team';
        }
        if (this.props[`${formName}IsValid`]) {
          this.setStepIndex(index);
        } else {
          this.props.setFormTouch(
            `${formName}`,
            Object.keys(this.props[`${formName}SyncErrors`])
          );
        }
      }
    } else {
      this.setStepIndex(index);
    }
  };

  submit = () => {
    if (this.props.applicants === 1) {
      if (
        this.props[`member${this.state.tabIndex + 1}IsValid`] &&
        this.props.termsOfServiceForm.termsOfService
      ) {
        this.props.submitApplicants(this.props.finalForm);
      } else {
        this.props.setFormTouch(
          `member${this.state.tabIndex + 1}`,
          Object.keys(this.props[`member${this.state.tabIndex + 1}SyncErrors`])
        );
        this.props.setFormTouch('termsOfServiceForm', ['termsOfService']);
      }
    } else {
      let formName = `member${this.state.tabIndex + 1}`;
      if (this.state.tabIndex === 0 && this.state.stepIndex === this.state.stepsCount) {
        formName = 'team';
      }
      if (
        this.props[`${formName}IsValid`] &&
        this.props.termsOfServiceForm.termsOfService
      ) {
        this.props.submitApplicants(this.props.finalForm);
      } else {
        this.props.setFormTouch(
          `${formName}`,
          Object.keys(this.props[`${formName}SyncErrors`])
        );
        this.props.setFormTouch('termsOfServiceForm', ['termsOfService']);
      }
    }
  };

  renderTips() {
    return (
      <GridColumn className="ui sixteen wide mobile five wide computer right floated">
        <div className="ui fluid card noShadow tip">
          <div
            className="content invertedPrimary"
            style={{ backgroundColor: `#${this.props.season.hexColorCodeC}` }}
          >
            <div className="header">
              <h4>Tip</h4>
            </div>
          </div>
          <div className="content shaded padded">
            <p>
              Make sure all of your information is correct before moving on to
              the next step!{' '}
            </p>
            <p>
              Do not refresh your browser while completing the application,
              otherwise your application progress will be lost and you must
              start again.{' '}
            </p>
          </div>
        </div>
      </GridColumn>
    );
  }

  render() {
    const { show, season, sections, loading, optionByField } = this.props;
    const { Element } = Scroll;
    const productionPrivacyPolicy = process.env.REACT_APP_PRODUCTION_PRIVACY_POLICY_URL;
    let collectionStatement = require('../assets/pdf/' + process.env.REACT_APP_COLLECTION_STATEMENT);
    if (!this.props.country) {
      return (
        <Redirect to="/home" />
      );
    }
    if (loading) {
      return (
        <Dimmer active inverted>
          <Loader size="large">Loading</Loader>
        </Dimmer>
      );
    }
    return (
      <div>
        <Container id="mainContent" className="ui">
          <Grid className="ui">
            <GridColumn className="pageShowTitle">
              <h3
                className="ui dividing header"
                style={{ color: `#${season.hexColorCodeC}` }}
              >
                {show.name} Casting
              </h3>
              <Button
                onClick={this.toggleVisibility}
                id="applyToggle"
                className="tiny ui primary tablet-down mobileToggle"
              >
                <Icon className="sidebar" />
                Tips
              </Button>
            </GridColumn>
          </Grid>

          <MobileTips
            tips={tips}
            hexColorCodeC={season.hexColorCodeC}
            visible={this.state.visible}
            toggleVisibility={this.toggleVisibility}
          />

          <Grid className="ui stackable" onClick={this.closeMenu}>
            <GridColumn className="ui sixteen wide mobile eight wide computer">
              <h1>Apply!</h1>
              <p className="lead">Welcome to the {show.name} application.</p>
              {this.underEighteen == "1" && (
                <p className="lead">For children under 18, a parent or guardian must fill in the application.</p>
              )}
              <p>
                This needs to be done in{' '}
                <strong style={{ color: `#${season.hexColorCodeC}` }}>
                  ONE
                </strong>{' '}
                sitting. Please make sure you have a picture of the person you are nominating so you can add it to the
                application easily.
              </p>

              <p>
                If you nominate someone else, you must have obtained their consent to provide their details (and any images) you submit. If your application includes details (including images) of anyone other than you, you must have obtained each person’s consent to provide those details about them.
              </p>


              {/*<p>applicants:{this.props.applicants},*/}
              {/*  stepsCount: {this.state.stepsCount},*/}
              {/*  tabsBySteps: {this.state.tabsBySteps[this.state.stepIndex]},*/}
              {/*  stepIndex: {this.state.stepIndex},*/}
              {/*  tabIndex: {this.state.tabIndex},*/}
              {/*  skipPhoto: {this.state.skipPhoto ? 'true' : 'false'},*/}
              {/*  skipVideo: {this.state.skipVideo ? 'true' : 'false'},*/}
              {/*  isFinalStep: {this.state.isFinalStep ? 'true' : 'false'}*/}
              {/*</p>*/}
              {/*<p>*/}
              {/*  {this.state.before}*/}
              {/*</p>*/}
              {/*<p>*/}
              {/*  {this.state.after}*/}
              {/*</p>*/}


              <div className="apply">
                <Element name="applyProgress">
                  <div className="applyProgress">
                    <div
                      className={classnames('applyStep', {
                        active: this.state.stepIndex === 1,
                      })}
                    >
                      <span>1</span>
                    </div>
                    <div
                      className={classnames('applyStep', {
                        active: this.state.stepIndex === 2,
                      })}
                    >
                      <span>2</span>
                    </div>
                    {(this.state.stepsCount >= 3) && (<div
                      className={classnames('applyStep', {
                        active: this.state.stepIndex === 3,
                      })}
                    >
                      <span>3</span>
                    </div>
                    )}
                    {(this.state.stepsCount >= 4) && (
                      <div
                        className={classnames('applyStep', {
                          active: this.state.stepIndex === 4,
                        })}
                      >
                        <span>4</span>
                      </div>
                    )}
                  </div>
                </Element>
                {this.state.stepIndex === 1 && (
                  <Step1
                    season={season}
                    sections={sections}
                    hexColorCodeC={season.hexColorCodeC}
                    optionByField={optionByField}
                    applicants={this.props.applicants}
                    tabIndex={this.state.tabIndex}
                    setTabIndex={() => { }}
                  />
                )}
                {this.state.stepIndex === 2 && (
                  <Step2
                    sections={sections}
                    hexColorCodeC={season.hexColorCodeC}
                    optionByField={optionByField}
                    applicants={this.props.applicants}
                    tabIndex={this.state.tabIndex}
                    setTabIndex={() => { }}
                  />
                )}
                {this.state.stepIndex === 3 && !(this.state.skipPhoto) && (
                  <Step3
                    season={season}
                    sections={sections}
                    hexColorCodeC={season.hexColorCodeC}
                    optionByField={optionByField}
                    applicants={this.props.applicants}
                    tabIndex={this.state.tabIndex}
                    setTabIndex={() => { }}
                  />
                )}
                {((this.state.stepIndex === 3 && this.state.skipPhoto && !(this.state.skipVideo)) || (this.state.stepIndex === 4)) && (
                  <Step4
                    season={season}
                    sections={sections}
                    hexColorCodeC={season.hexColorCodeC}
                    optionByField={optionByField}
                    applicants={this.props.applicants}
                    tabIndex={this.state.tabIndex}
                    setTabIndex={() => { }}
                  />
                )}
              </div>
              {this.state.isFinalStep && (
                <div style={{ marginBottom: '40px' }}>
                  <p>
                    Network Ten Pty Ltd is collecting your information so we can record your application and administer the assessment and casting process. Please refer to our privacy {' '}<a style={{ color: `#${season.hexColorCodeC}` }} href={collectionStatement} target="_blank" rel="noopener noreferrer">
                      Collection Statement
                    </a>.
                  </p>
                  <TermsOfService form="termsOfServiceForm" />
                  <p>
                    By ticking the box and submitting an application I agree to the Application Terms and that Network Ten Pty Ltd and Paramount Global may use my information and the information I have submitted in accordance with its {' '}<a style={{ color: `#${season.hexColorCodeC}` }} href={productionPrivacyPolicy} target="_blank" rel="noopener noreferrer">
                      Production Privacy Policy
                    </a>.
                  </p>

                </div>

              )}
              <div className="ui grid applyNav">
                <div className="eight wide mobile six wide tablet six wide computer column">
                  {(this.state.stepIndex > 1 || this.state.tabIndex > 0) && (
                    <div
                      className="ui fluid huge left labeled icon button"
                      onClick={() => this.changeStep(-1)}
                    >
                      <i className="left chevron icon" />
                      Back
                    </div>
                  )}
                </div>
                <div className="eight wide mobile six wide tablet six wide computer column">
                  {!this.state.isFinalStep && (
                    <div
                      className="ui fluid huge primary right labeled icon button"
                      style={{ backgroundColor: `#${season.hexColorCodeC}` }}
                      onClick={() => this.changeStep(1)}
                    >
                      <i className="right chevron icon" />
                      Next
                    </div>
                  )}
                  {this.state.isFinalStep && (
                    <div
                      className="ui fluid huge primary right labeled icon button"
                      style={{ backgroundColor: `#${season.hexColorCodeC}` }}
                      onClick={this.submit}
                    >
                      <i className="right chevron icon" />
                      Submit!
                    </div>
                  )}
                </div>
              </div>
            </GridColumn>

            {this.renderTips()}
          </Grid>
        </Container>
      </div>
    );
  }
}

const mapStatesToProps = state => {
  const newState = {
    sections: state.formStructure.sections,
    optionByField: state.formStructure.optionByField,
    applicants: state.showSeason.applicants,
    loading: state.formStructure.loading,
    termsOfServiceForm: getFormValues('termsOfServiceForm')(state),
    finalForm: {
      members: [],
      team: [],
    },
    country: state.country.selected,
  };
  for (let i = 0; i < state.showSeason.applicants; i++) {
    newState[`member${i + 1}IsValid`] = isValid(`member${i + 1}`)(state);
    newState[`member${i + 1}SyncErrors`] = getFormSyncErrors(`member${i + 1}`)(
      state
    );
    newState.finalForm.members.push(getFormValues(`member${i + 1}`)(state));
  }
  if (state.showSeason.applicants > 1) {
    newState.teamIsValid = isValid('team')(state);
    newState.teamSyncErrors = getFormSyncErrors('team')(state);
    newState.finalForm.team.push(getFormValues('team')(state));
  }

  return newState;
};

const mapDispatchToProps = dispatch => ({
  getFormInformation: (seasonId, countrySfId) =>
    dispatch(formStructureActions.getFormBySeason(seasonId, countrySfId)),
  submitApplicants: applicants =>
    dispatch(showSeasonActions.submitApplicants(applicants)),
  setFormTouch: (formName, fields) => dispatch(touch(formName, ...fields)),
});

export default connect(mapStatesToProps, mapDispatchToProps)(Apply);



// WEBPACK FOOTER //
// ./src/components/Apply.js